// Slow editorial marquee. Duplicated content for a seamless loop.
export const Marquee = ({ items, className = "" }) => (
  <div className={`relative overflow-hidden select-none ${className}`} aria-hidden="true">
    <div className="flex w-max animate-marquee will-change-transform">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif text-5xl md:text-7xl lg:text-8xl font-light px-8 md:px-14 whitespace-nowrap">
                {item}
              </span>
              <span className="text-bronze text-3xl md:text-5xl font-light">—</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
